import { useSetAtom } from 'jotai';
import { useCallback,useState } from 'react';

import { clearInventorySelectionAtom } from '../../atoms/inventorySelectionAtoms';
import { useArchiveInventorySelection } from '../../hooks/useArchiveInventorySelection';

interface UseArchiveActionsParams {
	selectedIds: Set<string>;
}

/**
 * Custom hook that provides action handlers for archiving inventory items
 * Manages archive modal state and handles archive confirmation flow
 */
export const useArchiveActions = ({ selectedIds }: UseArchiveActionsParams) => {
	const { archiveItemsByIds, isPending: isArchiving } = useArchiveInventorySelection();
	const clearSelection = useSetAtom(clearInventorySelectionAtom);

	// Archive modal state
	const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);

	// Handle opening archive modal
	const handleOpenArchiveModal = useCallback(() => {
		setIsArchiveModalOpen(true);
	}, []);

	// Handle archive confirmation
	const handleArchiveConfirm = useCallback(async () => {
		// Fetch items using query hooks and archive ready items
		await archiveItemsByIds(selectedIds);
		clearSelection();
	}, [archiveItemsByIds, selectedIds, clearSelection]);

	// Handle archive cancel
	const handleArchiveCancel = useCallback(() => {
		setIsArchiveModalOpen(false);
	}, []);

	return {
		isArchiveModalOpen,
		setIsArchiveModalOpen,
		isArchiving,
		handleOpenArchiveModal,
		handleArchiveConfirm,
		handleArchiveCancel,
	};
};
